import { BILLING_KEY_TRANSLATION, DELIVERY_TYPE_TRANSLATION } from '../constants/translation'
import { camelToSnake } from './utils'
import { comunasVtex } from '../constants/states'

export const addressParser = (address) => {
  const addressParser = address.split(', ')
  const region = addressParser[2]
  const regionWithoutPostcode = region.slice(0, addressParser[2].length - 8)
  addressParser[2] = regionWithoutPostcode
  return addressParser
}

export const addressParserUnnormalized = (address) => {
  const addressParserUnnormalized = address.split(',')
  if (addressParserUnnormalized.length === 2) {
    return [addressParserUnnormalized[0], addressParserUnnormalized[1], '']
  } else {
    return addressParserUnnormalized.slice(0, 3)
  }
}

export const normalizeRegionName = (region) => {
  const normalizedRegionName = region
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace("'", '')
    .replace('Región del ', '')
    .replace('Región de ', '')
    .replace('Region de ', '')
    .replace('Region del ', '')
    .replace('Region ', '')
    .replace(/[" "][0-9]+/g, '')
    .replace('Biobio', 'Bio Bio')

  return normalizedRegionName
}

export const regionIdApi = {
  Tarapaca: '1',
  Antofagasta: '2',
  Atacama: '3',
  Coquimbo: '4',
  Valparaiso: '5',
  OHiggins: '6',
  Maule: '7',
  'Bio Bio': '8',
  Biobio: '8',
  'La Araucania': '9',
  'Los Lagos': '10',
  'Aysen del General Carlos Ibanez del Campo': '11',
  'Magallanes y de la Antartica Chilena': '12',
  'Metropolitana de Santiago': '13',
  'Los Rios': '14',
  'Arica y Parinacota': '15',
  Nuble: '16'
}

export const getRegionById = regionId => {
  return Object.keys(regionIdApi).filter(
    region => regionIdApi[region] === regionId
  )[0]
}

export const regionCode = {
  Tarapaca: 'TA',
  Antofagasta: 'AN',
  Atacama: 'AT',
  Coquimbo: 'CO',
  Valparaiso: 'VS',
  'Libertador General Bernardo OHiggins': 'LI',
  OHiggins: 'LI',
  Maule: 'ML',
  'Bio Bio': 'BI',
  Biobio: 'BI',
  'La Araucania': 'AR',
  'Los Lagos': 'LL',
  'Aysen del General Carlos Ibanez del Campo': 'AI',
  'Magallanes y de la Antartica Chilena': 'MA',
  'Metropolitana de Santiago': 'RM',
  Metropolitana: 'RM',
  'Los Rios': 'LR',
  'Arica y Parinacota': 'AP',
  Nuble: 'NB',
  'I Region': 'TA',
  'II Region': 'AN',
  'III Region': 'AT',
  'IV Region': 'CO',
  'V Region': 'VS',
  'VI Region': 'LI',
  'VII Region': 'ML',
  'VIII Region': 'BI',
  'IX Region': 'AR',
  'X Region': 'LL',
  'XI Region': 'AI',
  'XII Region': 'MA',
  'XIV Region': 'LR',
  'XV Region': 'AP',
  'XVI Region': 'NB'
}

export const shippingAddressObject = (userInfo, addressInfo, companyInfo) => {
  const { companyName } = companyInfo
  const { names, rut, phone } = userInfo
  const {
    userAddress,
    price,
    deliveryType,
    district,
    aditionalInfo,
    region,
    serviceType,
    courier
  } = addressInfo

  const firstName = names.substring(0, names.indexOf(' '))
  const lastName = names.substring(names.indexOf(' ') + 1)
  const complementPrice = serviceType ? `${courier} - ${serviceType}` : 'standard'
  const address2 = `${price} - ${DELIVERY_TYPE_TRANSLATION[deliveryType]} - ${complementPrice}`

  const shippingAddress = {
    address1: userAddress,
    address2: companyName !== 'Killstore' ? address2 : '',
    city: district,
    company: companyName === 'SELFIE' ? rut : aditionalInfo,
    country: 'Chile',
    firstName,
    lastName,
    phone,
    province: regionCode[normalizeRegionName(region)] || '',
    zip: companyName === 'SELFIE' ? aditionalInfo : rut
  }

  return shippingAddress
}

export const shippingAddressParser = shippingAddress => {
  const addressParsed = Object.keys(shippingAddress)
    .filter(
      key => shippingAddress[key] !== ''
    )
    .map(
      key =>
        `checkout[shipping_address][${camelToSnake(key)}]=${shippingAddress[key]
        }`
    )
    .join('&')

  return addressParsed !== '' ? `&${addressParsed}` : ''
}

export const billingUrlParser = billingInfo => {
  return Object.keys(billingInfo)
    .filter(
      key => billingInfo[key] !== ''
    )
    .map(
      key =>
        `attributes[${BILLING_KEY_TRANSLATION[key]}]=${billingInfo[key]
        }`
    )
    .join('&')
}

export const billingInputParser = billingInfo => {
  const customAttributes = []
  Object.keys(billingInfo).forEach((key) => {
    customAttributes.push({
      key: BILLING_KEY_TRANSLATION[key],
      value: billingInfo[key]
    })
  })
  return { customAttributes }
}

export const changedRegionName = (oldName) => {
  const newNames = {
    TA: 'Región de Tarapacá (I)',
    AN: 'Región de Antofagasta (II)',
    AT: 'Región de Atacama (III)',
    CO: 'Región de Coquimbo (IV)',
    VS: 'Región de Valparaíso (V)',
    LI: 'Región del Libertador General Bernardo O’Higgins (VI)',
    ML: 'Región del Maule (VII)',
    BI: 'Región del Biobío (VIII)',
    AR: 'Región de La Araucanía (IX)',
    LL: 'Región de Los Lagos (X)',
    AI: 'Región de Aysén del General Carlos Ibáñez del Campo (XI)',
    MA: 'Región de Magallanes y la Antártica Chilena (XII)',
    RM: 'Región Metropolitana',
    LR: 'Región de Los Ríos (XIV)',
    AP: 'Región de Arica y Parinacota (XV)',
    NB: 'Región del Ñuble (XVI)'
  }
  const code = regionCode[normalizeRegionName(oldName)]
  return newNames[code]
}

export const getFullAdress = (street, number, additionalInfo) => {
  let address = `${street} ${number}`
  address += additionalInfo ? `, ${additionalInfo}` : ''
  return address
}

export const getAddressObject = (place) => {
  let address, district, region
  if (place.place_type[0] === 'address') {
    address = `${place.text} ${place.address}`
    district = place.context.filter((context) => context.id.includes('place'))[0].text
    region = place.context.filter((context) => context.id.includes('region'))[0].text
  } else if (place.place_type[0] === 'place') {
    district = place.text
    region = place.context.filter((context) => context.id.includes('region'))[0].text
  } else if (place.place_type[0] === 'region') {
    region = place.text
  }

  const addressObject = {
    address,
    district,
    region,
    aditionalInfo: '',
    geoCoordinates: place.center
  }
  return addressObject
}

// código para hacer similaridad entre comunas para colgram
const editDistance = (s1, s2) => {
  s1 = s1.toLowerCase()
  s2 = s2.toLowerCase()

  const costs = []
  for (let i = 0; i <= s1.length; i++) {
    let lastValue = i
    for (let j = 0; j <= s2.length; j++) {
      if (i === 0) costs[j] = j
      else {
        if (j > 0) {
          let newValue = costs[j - 1]
          if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
            newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1
          }
          costs[j - 1] = lastValue
          lastValue = newValue
        }
      }
    }
    if (i > 0) costs[s2.length] = lastValue
  }
  return costs[s2.length]
}

const similarity = (s1, s2) => {
  let longer = s1
  let shorter = s2
  if (s1.length < s2.length) {
    longer = s2
    shorter = s1
  }
  const longerLength = longer.length
  if (longerLength === 0) {
    return 1.0
  }
  return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength)
}

export const setCitySelect = (region, mapCityName) => {
  const cityOptions = comunasVtex[region]
  let bestCandidateOption = cityOptions[0]
  let currentSim = 0
  let currentOption
  for (let i = 0; i < cityOptions.length; i++) {
    currentOption = cityOptions[i]
    const sim = similarity(mapCityName, currentOption)
    if (sim > currentSim) {
      currentSim = sim
      bestCandidateOption = currentOption
    }
  }

  return bestCandidateOption
}
